import { Toaster as Sonner, toast } from "sonner";

const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      theme="dark"
      position="bottom-right"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-zinc-900 group-[.toaster]:text-white group-[.toaster]:border-zinc-800 group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-zinc-400",
          actionButton:
            "group-[.toast]:bg-emerald-500 group-[.toast]:text-white",
          cancelButton:
            "group-[.toast]:bg-zinc-800 group-[.toast]:text-zinc-400",
          success: "group-[.toaster]:bg-emerald-900/90 group-[.toaster]:border-emerald-700",
          error: "group-[.toaster]:bg-red-900/90 group-[.toaster]:border-red-700",
          warning: "group-[.toaster]:bg-amber-900/90 group-[.toaster]:border-amber-700",
          info: "group-[.toaster]:bg-blue-900/90 group-[.toaster]:border-blue-700",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
